export default __webpack_public_path__ + "static/media/minder.ec98815a.png";